module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/nervousness/6868578be150d0007ba18b6178a0dd69.png";